import { IController } from 'angular';
import * as _ from 'lodash';

import { WizardUtils } from './../../../../../../../shared/services/wizard-utils/wizard-utils.service';
import { IWizardFilterActionsOptions } from './../../../../../components/wizard-filter-actions/wizard-filter-actions.typings';

interface IFinalCheck {
  data: string[];
  options: IWizardFilterActionsOptions;
}

export class ExamLoadCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils'];

  public filteredStudents;
  public studentsWithConflictingExams: IFinalCheck;
  public studentsPlannedForThreeOrMore: IFinalCheck;
  public studentsPlannedForExamsAttemptedThreeOrMoreTimes: IFinalCheck;
  public studentsNotPlannedForNeededExamWithNoExamsPlannedInNextAdmin: IFinalCheck;
  public studentsPlannedForRegentsExamsBeyondGradDate: IFinalCheck;

  constructor(public $scope, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    const buckets = this.getStudentBuckets(this.filteredStudents);
    // wizard-filter-options:
    this.studentsWithConflictingExams = {
      data: buckets.studentsWithConflictingExams,
      options: {
        columnKeys: ['countOfRegentsExamsWithConclicts', 'regentsSchedForNextAdmin'],
      },
    };

    this.studentsPlannedForThreeOrMore = {
      data: buckets.studentsPlannedForThreeOrMore,
      options: {
        columnKeys: ['countOfRegentsSchedForNextAdmin', 'regentsSchedForNextAdmin', 'regentsNeededForOnTrackDiploma'],
      },
    };

    this.studentsPlannedForExamsAttemptedThreeOrMoreTimes = {
      data: buckets.studentsPlannedForExamsAttemptedThreeOrMoreTimes,
      options: {
        columnKeys: [
          'regentsSchedForNextAdmin',
          'countOfRegentsSchedNextAdminAttemptedThreeOrMoreTimes',
          'regentsSchedNextAdminAttemptedThreeOrMoreTimes',
        ],
      },
    };

    this.studentsNotPlannedForNeededExamWithNoExamsPlannedInNextAdmin = {
      data: buckets.studentsNotPlannedForNeededExamWithNoExamsPlannedInNextAdmin,
      options: {
        columnKeys: ['regentsNeededForOnTrackDiploma', 'regentsSchedForNextAdmin'],
      },
    };

    this.studentsPlannedForRegentsExamsBeyondGradDate = {
      data: buckets.studentsPlannedForRegentsExamsBeyondGradDate,
      options: {
        columnKeys: [
          'plannedGraduationDate',
          'countOfRegentsExamsPlannedBeyondStudentsGradDate',
          'regentsExamsPlannedBeyondStudentsGradDate',
        ],
      },
    };
  }

  private getStudentBuckets(students) {
    const baseObj = {
      studentsWithConflictingExams: [],
      studentsPlannedForThreeOrMore: [],
      studentsPlannedForExamsAttemptedThreeOrMoreTimes: [],
      studentsNotPlannedForNeededExamWithNoExamsPlannedInNextAdmin: [],
      studentsPlannedForRegentsExamsBeyondGradDate: [],
    };
    return _.reduce(
      students,
      (
        result,
        {
          studentId,
          countOfRegentsExamsWithConclicts: examConflicts,
          countOfRegentsSchedForNextAdmin: examLoad,
          countOfRegentsSchedNextAdminAttemptedThreeOrMoreTimes: examsPlannedWith3Attempts,
          countOfRegentsNeededForOnTrackDiploma: examsNeeded,
          countOfRegentsExamsPlannedBeyondStudentsGradDate: examsBeyond,
        },
      ) => {
        if (examConflicts > 0) result.studentsWithConflictingExams.push(studentId);
        if (examLoad >= 3) result.studentsPlannedForThreeOrMore.push(studentId);
        if (examsPlannedWith3Attempts > 0) result.studentsPlannedForExamsAttemptedThreeOrMoreTimes.push(studentId);
        if (examLoad === 0 && examsNeeded > 0) {
          result.studentsNotPlannedForNeededExamWithNoExamsPlannedInNextAdmin.push(studentId);
        }
        if (examsBeyond > 0) {
          result.studentsPlannedForRegentsExamsBeyondGradDate.push(studentId);
        }
        return result;
      },
      baseObj,
    );
  }
}
